import { useState } from 'react';
import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { AppBar, Box, Button, Toolbar, Typography } from '@material-ui/core';
import type { Theme } from '@material-ui/core';
import { ChevronDown as ChevronDownIcon } from '../icons/chevron-down';
import { useSettings } from '../contexts/settings-context';
import { AccountPopover } from './account-popover';
// import { Logo } from './logo';
import { DashboardNavbarMenu } from './dashboard-navbar-menu';

export const DashboardNavbar: FC = () => {
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const { settings, saveSettings } = useSettings();
  const [openMenu, setOpenMenu] = useState(false);
  const [darkMode, setDarkMode] = useState(settings.theme === 'dark');

  const handleSwitchTheme = (): void => {
    saveSettings({
      ...settings,
      theme: settings.theme === 'light' ? 'dark' : 'light'
    });

    setDarkMode(settings.theme === 'light');
  };

  return (
    <AppBar
      elevation={0}
      sx={{ backgroundColor: 'primary.dark' }}
    >
      <Toolbar
        disableGutters
        sx={{
          alignItems: 'center',
          display: 'flex',
          minHeight: 64,
          px: 3,
          py: 1
        }}
      >
        <Box
          component={RouterLink}
          to="/"
          sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            pr: 1.5
          }}
        >
          <img
            src="/favicon-32x32.png"
            alt="emblem"
          />
        </Box>
        <Typography
          sx={{
            color: 'primary.contrastText',
            display: {
              md: 'flex',
              xs: 'none'
            },
            fontFamily: 'Tahoma',
            fontWeight: '100',

          }}
          variant="h5"
        >
          SERVCARE
        </Typography>
        <DashboardNavbarMenu
          onClose={() => setOpenMenu(false)}
          open={mdDown && openMenu}
        />
        <Button
          endIcon={(
            <ChevronDownIcon
              fontSize="small"
              sx={{
                ml: 2,
                transition: 'transform 250ms',
                transform: openMenu ? 'rotate(180deg)' : 'none'
              }}
            />
          )}
          onClick={() => setOpenMenu(true)}
          sx={{
            color: 'primary.contrastText',
            display: {
              md: 'none',
              xs: 'flex'
            }
          }}
          variant="text"
        >
          Menu
        </Button>
        <Box sx={{ flexGrow: 1 }} />
        <AccountPopover
          darkMode={darkMode}
          onSwitchTheme={handleSwitchTheme}
          showName={false}
          pinned={false}
          onPin={() => { }}
        />
      </Toolbar>
    </AppBar>
  );
};
